/* =============================================================
   PRx drawer triggers: open vendor drawers/modals without aria-controls

   ADA (Allyant #3, #200, #379): QA asked us to remove aria-controls from
   our drawer triggers. The vendor ModalElement only binds clicks to
   [aria-controls="<id>"], so our triggers use data-prx-opens="<id>" and
   this handler calls the drawer's public show(trigger) instead. That's the
   same call the vendor makes internally, so focus still returns to the
   trigger on close.

   Markup: <button type="button" data-prx-opens="CartDrawer" aria-haspopup="dialog">

   Loaded by sections/prx-secondary-nav.liquid and
   snippets/prx-modal-drawer.liquid; the guard keeps one listener.
   ============================================================= */
(() => {
  if (window.prxDrawerTriggerBound) return;
  window.prxDrawerTriggerBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-prx-opens]');
    if (!trigger) return;

    const drawer = document.getElementById(trigger.getAttribute('data-prx-opens'));
    if (!drawer || typeof drawer.show !== 'function') return; // fall back to the link/button default

    event.preventDefault();
    if (drawer.open && typeof drawer.hide === 'function') {
      drawer.hide();
    } else {
      drawer.show(trigger);
    }
  });
})();
